import { lazy } from 'react';
import { RemoteModule } from '../components/remote-module/remote-module';
import { UnicornApi } from '@cld/unicorn-api';

const RemoteMarketplace = lazy(() =>
  import('@cld-remote/marketplace/index').then(({ Marketplace }) => ({
    default: Marketplace,
  }))
);

export const Marketplace = ({ unicornApi }: { unicornApi: UnicornApi }) => {
  return (
    <RemoteModule>
      <RemoteMarketplace unicornApi={unicornApi} />
    </RemoteModule>
  );
};
